<template>
<div>
    <v-dialog v-model="open_add_food" persistent>
        <div v-if="loading_page_add_food === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_add_food === false">
            <v-form ref="form" @submit.prevent="addFood()">
                <v-card-title class="justify-end">
                    <div class="cursor_add_toppingmenu" @click="closeTopping()">
                        <v-icon>mdi-close</v-icon>
                    </div>
                </v-card-title>

                <v-card-text>
                    <div class="img_add_toppingmenu">
                        <img :src="food_detail.path">
                    </div>
                    <v-container>
                        <v-row>
                            <v-col cols="8">
                                <div>
                                    {{ selectedLanguage == 'en' && food_detail.nameEng ? food_detail.nameEng : food_detail.name }}
                                </div>
                            </v-col>
                            <v-col cols="4">
                                <div class="text-right">
                                    {{ food_detail.price }} ฿
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <div class="description_detailadd_toppingmenu">
                                    {{ food_detail.description }}
                                </div>
                                <v-divider></v-divider>
                            </v-col>
                            <!-- <v-col cols="12" v-if="food_detail.categoriesToping.length > 0">
                                <div>
                                    สามารถเลือกท๊อปปิ้งได้
                                </div>
                                <v-divider></v-divider>
                            </v-col> -->
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <div v-for="(detail,key) in food_detail.categoriesToping" :key="key">
                                    <div v-if="detail.choose == 0 && detail.status_limit == 0" class="mt-0">
                                        <div class="mt-2">
                                            <div>{{ selectedLanguage == 'en' && detail.name_en ? detail.name_en : detail.name }} <span>( {{ $t('canChoose') }} )</span></div>
                                            <div class="d-flex justify-space-between mt-2 font_add_food" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                <div class="d-flex" v-if="detail_list.status == 1">
                                                    <v-checkbox v-model="choice_topping[key].toppingList" :color="bg_color" :value="detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'+','+detail_list.name_en" class="check_food_pos_table_detail" @change="checkSendFood()"></v-checkbox>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }}</div>

                                                </div>
                                                <div class="d-flex" v-if="detail_list.status == 0">
                                                    <v-checkbox v-model="choice_topping[key].toppingList" :color="bg_color" class="check_food_pos_table_detail" disabled></v-checkbox>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }} <span class="out_of_stock_add_toppingmenu">({{ $t('stockLost') }})</span></div>
                                                </div>
                                                <div>
                                                    +{{ detail_list.price }} ฿
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="detail.choose == 0 && detail.status_limit == 1" class="mt-0">
                                        <div class="mt-2">
                                            <div>{{ selectedLanguage == 'en' && detail.name_en ? detail.name_en : detail.name }} <span>( {{ $t('canChooseNoMoreToppings')}} {{ detail.limit }} {{ $t('thenToppings') }} )</span></div>
                                            <div class="d-flex justify-space-between mt-2 font_add_food" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                <div class="d-flex" v-if="detail_list.status == 1">
                                                    <v-checkbox v-model="choice_topping[key].toppingList" :disabled="choice_topping[key].toppingList.length >= detail.limit && choice_topping[key].toppingList.indexOf(detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'+','+detail_list.name_en) === -1" :color="bg_color" :value="detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'" class="check_food_pos_table_detail" @change="checkSendFood()"></v-checkbox>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }}</div>
                                                </div>
                                                <div class="d-flex" v-if="detail_list.status == 0">
                                                    <v-checkbox v-model="choice_topping[key].toppingList" :color="bg_color" class="check_food_pos_table_detail" disabled></v-checkbox>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }} <span class="out_of_stock_add_toppingmenu">({{ $t('stockLost') }})</span></div>
                                                </div>
                                                <div>
                                                    +{{ detail_list.price }} ฿
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="detail.choose == 0 && detail.status_limit == 2" class="mt-0">
                                        <div class="mt-2">
                                            <div>{{ selectedLanguage == 'en' && detail.name_en ? detail.name_en : detail.name }} <span>( {{ $t('pleaseKeyQty') }} )</span></div>
                                            <div class="d-flex justify-space-between mt-2 font_add_food" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                <div class="d-flex" v-if="detail_list.status == 1">
                                                    <div class="d-flex align-center mr-2">
                                                        <div @click="addNumTopping('minus',key,key_detail)" class="cursor_icon_pos_table_detail">
                                                            <v-icon size="25">mdi-minus-circle</v-icon>
                                                        </div>
                                                        <div class="ml-1 mr-1 cursor_icon_pos_table_detail font_amount_topping_pos_table_detail" :key="detail_list.amount">
                                                            {{ detail_list.amount }}
                                                        </div>

                                                        <div @click="addNumTopping('plus',key,key_detail)" class="cursor_icon_pos_table_detail">
                                                            <v-icon size="25">mdi-plus-circle</v-icon>
                                                        </div>
                                                    </div>
                                                    <div>{{ selectedLanguage == 'en' && detail.name_en ? detail.name_en : detail.name }}</div>
                                                </div>
                                                <div class="d-flex" v-if="detail_list.status == 0">
                                                    <div class="d-flex align-center mr-2">
                                                        <div class="cursor_icon_pos_table_detail">
                                                            <v-icon size="25">mdi-minus-circle</v-icon>
                                                        </div>
                                                        <div class="ml-1 mr-1 cursor_icon_pos_table_detail font_amount_topping_pos_table_detail" :key="detail_list.amount">
                                                            {{ detail_list.amount }}
                                                        </div>

                                                        <div class="cursor_icon_pos_table_detail">
                                                            <v-icon size="25">mdi-plus-circle</v-icon>
                                                        </div>
                                                    </div>
                                                    <div>{{ selectedLanguage == 'en' && detail.name_en ? detail.name_en : detail.name }} <span class="out_of_stock_add_toppingmenu">({{ $t('stockLost') }})</span></div>
                                                </div>
                                                <div>
                                                    +{{ detail_list.price }} ฿
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="detail.choose == 1 && detail.status_limit == 0" class="mt-0">
                                        <div class="mt-2">
                                            <div>{{ selectedLanguage == 'en' && detail.name_en ? detail.name_en : detail.name }} <span>( {{ $t('pleaseSelectToping') }} )</span></div>
                                            <div class="d-flex justify-space-between mt-2 font_add_food" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                <div class="d-flex" v-if="detail_list.status == 1">
                                                    <v-checkbox v-model="choice_topping[key].toppingList" :color="bg_color" :value="detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'+','+detail_list.name_en" class="check_food_pos_table_detail" @change="checkSendFood()"></v-checkbox>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }}</div>
                                                </div>
                                                <div class="d-flex" v-if="detail_list.status == 0">
                                                    <v-checkbox v-model="choice_topping[key].toppingList" :color="bg_color" class="check_food_pos_table_detail" disabled></v-checkbox>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }} <span class="out_of_stock_add_toppingmenu">({{ $t('stockLost') }})</span></div>
                                                </div>
                                                <div>
                                                    +{{ detail_list.price }} ฿
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="detail.choose == 1 && detail.status_limit == 1" class="mt-0">
                                        <div class="mt-2">
                                            <div>
                                                {{ selectedLanguage == 'en' && detail.name_en ? detail.name_en : detail.name }}
                                                <span>( {{ $t('pleaseSelectToping') }} {{ $t('canChooseNoMoreToppings')}} {{ detail.limit }} {{ $t('thenToppings') }} )</span>
                                            </div>
                                            <div class="d-flex justify-space-between mt-2 font_add_food" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                <div class="d-flex" v-if="detail_list.status == 1">
                                                    <v-checkbox v-model="choice_topping[key].toppingList" :disabled="choice_topping[key].toppingList.length >= detail.limit && choice_topping[key].toppingList.indexOf(detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'+','+detail_list.name_en) === -1" :color="bg_color" :value="detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'+','+detail_list.name_en" class="check_food_pos_table_detail" @change="checkSendFood()"></v-checkbox>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }}</div>
                                                </div>
                                                <div class="d-flex" v-if="detail_list.status == 0">
                                                    <v-checkbox v-model="choice_topping[key].toppingList" :color="bg_color" class="check_food_pos_table_detail" disabled></v-checkbox>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }} <span class="out_of_stock_add_toppingmenu">({{ $t('stockLost') }})</span></div>
                                                </div>
                                                <div>
                                                    +{{ detail_list.price }} ฿
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="detail.choose == 1 && detail.status_limit == 2" class="mt-0">
                                        <div class="mt-2">
                                            <div>{{ selectedLanguage == 'en' && detail.name_en ? detail.name_en : detail.name }} <span>( {{ $t('pleaseKeyQty') }} )</span></div>
                                            <div class="d-flex justify-space-between mt-2 font_add_food" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                <div class="d-flex" v-if="detail_list.status == 1">
                                                    <div class="d-flex align-center mr-2">
                                                        <div @click="addNumTopping('minus',key,key_detail)" class="cursor_icon_pos_table_detail">
                                                            <v-icon size="25">mdi-minus-circle</v-icon>
                                                        </div>
                                                        <div class="ml-1 mr-1 cursor_icon_pos_table_detail font_amount_topping_pos_table_detail" :key="detail_list.amount">
                                                            {{ detail_list.amount }}
                                                        </div>

                                                        <div @click="addNumTopping('plus',key,key_detail)" class="cursor_icon_pos_table_detail">
                                                            <v-icon size="25">mdi-plus-circle</v-icon>
                                                        </div>
                                                    </div>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }}</div>
                                                </div>
                                                <div class="d-flex" v-if="detail_list.status == 0">
                                                    <div class="d-flex align-center mr-2">
                                                        <div class="cursor_icon_pos_table_detail">
                                                            <v-icon size="25">mdi-minus-circle</v-icon>
                                                        </div>
                                                        <div class="ml-1 mr-1 cursor_icon_pos_table_detail font_amount_topping_pos_table_detail" :key="detail_list.amount">
                                                            {{ detail_list.amount }}
                                                        </div>

                                                        <div class="cursor_icon_pos_table_detail">
                                                            <v-icon size="25">mdi-plus-circle</v-icon>
                                                        </div>
                                                    </div>
                                                    <div>{{ selectedLanguage == 'en' && detail_list.name_en ? detail_list.name_en : detail_list.name }} <span class="out_of_stock_add_toppingmenu">({{ $t('pleaseKeyQty') }})</span></div>
                                                </div>
                                                <div>
                                                    +{{ detail_list.price }} ฿
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <v-expansion-panels class="add_note_toppingmenu">
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('addNote') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-textarea outlined :label="$t('addNote')" v-model="description"></v-textarea>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div class="d-flex justify-center align-center">
                                    <div class="d-flex align-center">
                                        <div @click="addNumFood('minus')" class="cursor_icon_add_toppingmenu">
                                            <v-icon size="40">mdi-minus-circle</v-icon>
                                        </div>
                                        <div class="ml-2 mr-2" :key="add_num_food">
                                            {{ add_num_food }}
                                        </div>

                                        <div @click="addNumFood('plus')" class="cursor_icon_add_toppingmenu">
                                            <v-icon size="40">mdi-plus-circle</v-icon>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <div class="topping_out_add_toppingmenu" v-if="button_send_food">
                                    {{ $t('pleaseSelectToping') }}*
                                </div>
                                <div class="d-flex justify-center align-center">
                                    <v-btn height="50" width="100%" class="white--text color_btn" type="submit" :disabled="button_send_food">
                                        {{ $t('addCart') }}
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>

                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store'; // นำเข้า Vuex store
Vue.use(VueI18n);
const messages = {
  en: {
    backPage :'Backward',
    stockLost :'SOLD OUT',
    canChoose :'Can choose topping',
    canChooseNoMoreToppings :'You can choose no more than',
    thenToppings :'toppings',
    pleaseKeyQty :'Please enter quantity',
    pleaseSelectToping :'Please select topping',
    addNote :'Add note',
    addCart :'Add to cart'
  },
  th: {
    backPage :'ย้อนกลับ',
    stockLost :'ขออภัยสินค้าหมด',
    canChoose :'สามารถเลือกท๊อปปิ้งได้',
    canChooseNoMoreToppings :'สามารถเลือกท๊อปปิ้งได้ไม่เกิน',
    thenToppings :'อย่าง',
    pleaseKeyQty :'กรุณาใส่จำนวน',
    pleaseSelectToping :'กรุณาเลือกท็อปปิ้ง',
    addNote :'เพิ่มหมายเหตุ',
    addCart :'เพิ่มลงในตะกร้า'
  },
  
};
const i18n = new VueI18n({
  locale: store.state.lang, // กำหนดภาษาหลัก
  messages,
});
export default {
    i18n,
    data() {
        return {
            open_add_food: false,
            loading_page_add_food: true,
            bg_color: 'primary',
            choice_topping: [],
            button_send_food: false,
            description: '',
            add_num_food: 1,
            food_detail: null,
            type:null,
            selectedLanguage: store.state.lang,
        }
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    methods: {
        async colorRestaurant() {
            HTTP.get('/showColor')
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        this.$router.push('/nametakeoutuser')
                    }

                })
        },
        async addNumTopping(type, key_title, key_detail) {
            this.button_send_food = true
            let topingList = this.food_detail.categoriesToping[key_title].listToping[key_detail]
            if (type === 'plus') {
                topingList.amount += 1
            }
            if (type === 'minus' && topingList.amount > 0) {
                topingList.amount -= 1
            }

            let checkAll = []
            const chooseNumberAll = this.food_detail.categoriesToping.filter((detail) => {
                return detail.choose == 1 && detail.status_limit == 2
            })
            chooseNumberAll.forEach((listTopingList) => {
                let arr_topping = []
                for (let index = 0; index < listTopingList.listToping.length; index++) {
                    if (listTopingList.listToping[index].amount == 0) {
                        arr_topping.push(true)
                    }else{
                        arr_topping.push(false)
                    }
                }
                let checkTopping = arr_topping.some((detail) => {
                    return detail === false
                })
                if (checkTopping === true) {
                    checkTopping = false
                }else{
                    checkTopping = true
                }
                checkAll.push(checkTopping)
            })

            const chooseAll = this.choice_topping.filter((detail) => {
                return detail.choose == 1 && detail.status_limit != 2
            })
            chooseAll.forEach((detail) => {
                if (detail.status_limit == 0 && detail.toppingList.length <= 0 || detail.status_limit == 1 && detail.toppingList.length <= 0) {
                    checkAll.push(true)
                }else{
                    checkAll.push(false)
                }
            })

            this.button_send_food = checkAll.some((detail) => {
                return detail === true
            })
        },
        async addNumFood(type) {
            if (type === 'plus') {
                this.add_num_food += 1
            }
            if (type === 'minus' && this.add_num_food > 1) {
                this.add_num_food -= 1
            }
        },
        async checkSendFood() {
            this.button_send_food = true
            let checkAll = []
            const chooseNumberAll = this.food_detail.categoriesToping.filter((detail) => {
                return detail.choose == 1 && detail.status_limit == 2
            })
            chooseNumberAll.forEach((listTopingList) => {
                let arr_topping = []
                for (let index = 0; index < listTopingList.listToping.length; index++) {
                    if (listTopingList.listToping[index].amount == 0) {
                        arr_topping.push(true)
                    }else{
                        arr_topping.push(false)
                    }
                }
                let checkTopping = arr_topping.some((detail) => {
                    return detail === false
                })
                if (checkTopping === true) {
                    checkTopping = false
                }else{
                    checkTopping = true
                }
                checkAll.push(checkTopping)
            })

            const chooseAll = this.choice_topping.filter((detail) => {
                return detail.choose == 1 && detail.status_limit != 2
            })
            chooseAll.forEach((detail) => {
                if (detail.status_limit == 0 && detail.toppingList.length <= 0 || detail.status_limit == 1 && detail.toppingList.length <= 0) {
                    checkAll.push(true)
                }else{
                    checkAll.push(false)
                }
            })

            this.button_send_food = checkAll.some((detail) => {
                return detail === true
            })
        },
        async addFood() {
            if (this.$refs.form.validate()) {
                if (this.add_num_food > 0) {
                    this.open_add_food = false
                    let total = parseInt(this.food_detail.price) * this.add_num_food
                    let choice_topping_id = []
                    let choice_topping_name = []
                    let choice_topping_name_en = []
                    let toppingprice = 0
                    let toppingprice_list = []
                    let topping_arr_list = []
                    let amount_topping = []
                    this.choice_topping.forEach(toppingDetail => {
                        toppingDetail.toppingList.forEach(detail => {
                            let res = detail.split(',')
                            let res_id = res[0]
                            let res_price = res[1]
                            let res_name = res[2]
                            let res_amount = res[3]
                            let res_name_en = res[4]
                            choice_topping_id.push(res_id)
                            choice_topping_name.push(res_name)
                            choice_topping_name_en.push(res_name_en)
                            // total += parseInt(res_price)
                            toppingprice += parseInt(res_price * res_amount)
                            toppingprice_list.push(res_price)
                            amount_topping.push(parseInt(res_amount))
                            topping_arr_list.push({
                                id: parseInt(res_id),
                                price: parseInt(res_price),
                                amount: parseInt(res_amount),
                                description: this.description.replace(this.$store.state.checkEmoji, ""),
                            })
                        })
                    })

                    this.food_detail.categoriesToping.forEach(detail => {
                        if (detail.status_limit == 2) {
                            detail.listToping.forEach(detail_list => {
                                if (detail_list.amount > 0) {
                                    choice_topping_id.push(detail_list.id)
                                    choice_topping_name.push(detail_list.name)
                                    choice_topping_name_en.push(detail_list.name_en)
                                    toppingprice += parseInt(detail_list.price * detail_list.amount)
                                    toppingprice_list.push(detail_list.price)
                                    amount_topping.push(detail_list.amount)
                                    topping_arr_list.push({
                                        id: parseInt(detail_list.id),
                                        price: parseInt(detail_list.price),
                                        amount: parseInt(parseInt(detail_list.amount)),
                                        description: this.description.replace(this.$store.state.checkEmoji, ""),
                                    })
                                }
                            })
                        }
                    })
                    const cartList = {
                        foodmenu_id: this.food_detail.id,
                        name: this.food_detail.name,
                        nameEng:this.food_detail.nameEng,
                        amount: this.add_num_food,
                        price: parseInt(this.food_detail.price),
                        total_price: total,
                        toping_id: choice_topping_id.toString(),
                        topping_name: choice_topping_name,
                        topping_name_en: choice_topping_name_en,
                        amount_topping: amount_topping,
                        toppingprice: toppingprice,
                        toppingprice_list: toppingprice_list,
                        topping_arr_list: topping_arr_list,
                        description: this.description.replace(this.$store.state.checkEmoji, ""),
                        type:this.type,
                    }

                    if (this.$route.name == 'buffetUser' || this.$route.name == 'singleDishMealUser') {
                        this.$store.commit('addCartListUser', cartList)
                    }
                    if (this.$route.name == 'takeOutUserTable') {
                        this.$store.commit('addCartTakeOutTableListUser', cartList)
                    }
                    if (this.$route.name == 'takeOutUser') {
                        this.$store.commit('addCartListUserTakeOut', cartList)
                    }
                    if (this.$route.name == 'orderOnlinePickUp') {
                        this.$store.commit('addCartOrderOnlineUser', cartList)
                    }
                    this.description = ''
                    this.add_num_food = 1

                }
            }
        },
        async closeTopping() {
            this.open_add_food = false
        },
    },
    mounted() {
        this.colorRestaurant()
        this.$root.$on('getDetail', (data) => {

            this.loading_page_add_food = true
            this.choice_topping = []
            this.description = ''
            this.add_num_food = 1
            this.button_send_food = false
            this.open_add_food = true
            this.type = data.type
            if (data.type !== null) {
                HTTP.get('/customer/detail-food-menu/' + data.id + '?type=' + data.type)
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.food_detail = response.data.fooddetail
                            for (let index = 0; index < response.data.fooddetail.categoriesToping.length; index++) {
                                this.choice_topping.push({
                                    choose: response.data.fooddetail.categoriesToping[index].choose,
                                    status_limit: response.data.fooddetail.categoriesToping[index].status_limit,
                                    limit: response.data.fooddetail.categoriesToping[index].limit,
                                    toppingList: []
                                })

                                if (response.data.fooddetail.categoriesToping[index].choose == 1) {
                                    this.button_send_food = true
                                }
                            }
                            this.loading_page_add_food = false
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
            if (data.type === null) {
                HTTP.get('/customer/detail-food-menu/' + data.id)
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.food_detail = response.data.fooddetail
                            for (let index = 0; index < response.data.fooddetail.categoriesToping.length; index++) {
                                this.choice_topping.push({
                                    choose: response.data.fooddetail.categoriesToping[index].choose,
                                    status_limit: response.data.fooddetail.categoriesToping[index].status_limit,
                                    limit: response.data.fooddetail.categoriesToping[index].limit,
                                    toppingList: []
                                })

                                if (response.data.fooddetail.categoriesToping[index].choose == 1) {
                                    this.button_send_food = true
                                }
                            }

                            this.loading_page_add_food = false
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }

        })
    }
}
</script>

<style scoped>
.color_btn {
  background: #4caf50 !important;
}

.cursor_add_toppingmenu {
    cursor: pointer;
}

.img_add_toppingmenu {
    width: 200px;
    margin: auto;
}

.img_add_toppingmenu>img {
    max-width: 100%;
}

.check_food_add_toppingmenu {
    padding: 0 !important;
    margin: 0 !important;
}

.cursor_icon_add_toppingmenu {
    cursor: pointer;
}

.topping_out_add_toppingmenu {
    color: #ff5252;
}

.description_detailadd_toppingmenu {
    color: #696969;
}

.out_of_stock_add_toppingmenu {
    color: #ff5252;
}

.add_note_toppingmenu>>>.v-expansion-panel::before {
    -webkit-box-shadow: unset;
    box-shadow: unset;
}

.add_note_toppingmenu>>>.v-expansion-panel-header {
    padding: 0;
    width: auto;
}

.add_note_toppingmenu>>>.v-expansion-panel-content__wrap {
    padding: 0 0 16px;
    color: #696969;
}
</style>
